module.exports = __webpack_public_path__ + "media/flat/unionpay-3d7f15f9.svg";